module.exports = __webpack_public_path__ + "static/img/Base + Pic.8072468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/Base + Pic.png
// module id = A+2A
// module chunks = 37